import { useContext } from "react";
import { DrawerCollectionsContext } from "../context/DrawerCollectionsContext";

const useDrawerCollections = () => {
  const { isActive, setIsActive } = useContext(DrawerCollectionsContext);
  return [isActive, setIsActive];
};

export default useDrawerCollections;
